module.exports = __webpack_public_path__ + "img/infobel_bg.a9b48ce5.png";